/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

type Props = {
  className?: string
  title: string
  value: string
  unit: string
  timestamp: string
  isOnline: boolean
  avatar: string
  status: string
  deviceId: string
  parameterId: string
}

const ParameterWidget: React.FC<Props> = ({
  className = '',
  title,
  value,
  unit,
  timestamp,
  isOnline,
  avatar,
  status,
  deviceId,
  parameterId,
}) => {
  return (
    <Link to={`/device/${deviceId}/parameter/${parameterId}`}>
      <div className={`card ${className}`}>
        <div className='card-body d-flex align-items-center pt-4 pb-4'>
          <div className='d-flex flex-column flex-grow-1'>
            <div className='fw-bold fs-5 mb-1 text-primary'>{title}</div>
            <div className='fw-bold fs-3 mb-2'>
              {Number(value).toFixed(2)} <small className='text-muted'>{unit}</small>
            </div>
            <div className='text-muted fw-semibold fs-7 mb-2'>{timestamp}</div>

            {status == 'N' ? (
              <span className='badge mt-1 badge-light-success w-auto d-inline-block'>Normal</span>
            ) : status == 'O' ? (
              <span className='badge mt-1 badge-light-danger w-auto d-inline-block'>Over</span>
            ) : (
              <span className='badge mt-1 badge-light-dark w-auto d-inline-block'>{status}</span>
            )}
          </div>

          <img src={toAbsoluteUrl(avatar)} alt='icon' className='ms-3 h-70px' />
        </div>
      </div>
    </Link>
  )
}

export {ParameterWidget}
